import { coerceBooleanProperty } from "@angular/cdk/coercion";
import { Component, Input, ViewChild } from "@angular/core";
import { AbstractControl } from "@angular/forms";

import { FormErrorsListComponent } from "@lantern/app/common/forms/form-errors-list/form-errors-list.component";

@Component({
  selector: "ta-form-field",
  templateUrl: "form-field.template.html",
  styles: ["./form-field.styles.css"]
})
export class FormFieldComponent {
  @ViewChild(FormErrorsListComponent, { static: false })
  errorsListComponent: FormErrorsListComponent;

  @Input()
  label?: string;

  @Input()
  description?: string;

  @Input()
  tooltipMsg?: string;

  @Input()
  control?: AbstractControl;

  @Input()
  errors?: Record<string, any>;

  @Input()
  dirty = false;

  @Input()
  forceShowErrors: boolean = false;

  @Input()
  hideLabel = false;

  @Input()
  set uppercaseLabel(value: boolean) {
    this._uppercaseLabel = coerceBooleanProperty(value);
  }
  get uppercaseLabel(): boolean {
    return this._uppercaseLabel;
  }
  _uppercaseLabel: boolean = false;

  @Input()
  hideDescription = false;

  /**
   * Three conditions for showing errors:
   * - if forceShowErrors is true
   * - if errors & dirty are input, errors is null, and dirty is true
   * - if control is input, it's not pristine, and it has errors
   */
  get showErrors(): boolean {
    return (
      this.forceShowErrors ||
      (this.dirty === true &&
        this.errors != null &&
        Object.keys(this.errors).length > 0) ||
      (this.control != null &&
        this.control.pristine === false &&
        this.control.errors != null)
    );
  }

  get errorsMap(): any {
    if (this.errors != null) {
      return this.errors;
    }
    if (this.control != null && this.control.errors != null) {
      return this.control.errors;
    }
  }
}
